import React from 'react';
import { Lock } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import type { Confidentiality } from '../types';

/**
 * Puur visuele markering -- de backend blijft de bron van waarheid over wie
 * een vertrouwelijk item mag zien (zie docs/#Leiderschap-Module.md,
 * "Vertrouwelijkheid: een extra laag bovenop de rol"). Dit label is nooit de
 * beveiligingslaag zelf.
 */
export default function ConfidentialBadge({ confidentiality }: { confidentiality: Confidentiality }) {
  if (confidentiality !== 'vertrouwelijk') return null;
  return (
    <Badge variant="outline" className="gap-1 border-amber-300 bg-amber-50 text-amber-800">
      <Lock className="h-3 w-3" />
      Vertrouwelijk
    </Badge>
  );
}
